import { FlightState } from "@/lib/redux/features/flight/type"
import { commonSort } from "./commonSort"
import { tierPrioritySort } from "./tierPrioritySort"

/**
 * Chọn cách xếp thứ tự HIỂN THỊ cuối cùng theo mode sort đang chọn:
 *  - 'default' (chưa bấm nút sort nào): ưu tiên theo tier hãng (tierPrioritySort).
 *  - 'cheapest' | 'earliest' | 'latest': hành vi CŨ, chỉ đẩy vé Galileo/1G xuống cuối (commonSort).
 */
export const applyResultOrdering = (state: FlightState, flightIds: any[]) =>
  state.flightsResult.sortBy === "default"
    ? tierPrioritySort(state, flightIds)
    : commonSort(state, flightIds)
